<div class="title">
  <mat-icon>person</mat-icon>
  Ownership
</div>
<div class="description">SELECT THE OWNERS TO FILTER BY</div>

<div class="lightMode search">
  <framework-search-profiles
    (chosenProfile)="add($any($event))"
    [placeholder]="'Search Users'"
    [resetOnSelected]="true"
    >
  </framework-search-profiles>
</div>

<div class="options">
  @for (user of owners; track user) {
    <elements-filter-chip
      icon="person"
      [caption]="user.displayName"
      [selected]="true"
      (click)="remove(user)"
      suffixIcon="close"
      >
    </elements-filter-chip>
  }
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
